'use client'
import React, { useState, useEffect, useRef } from 'react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useDraggable } from 'react-use-draggable-scroll'

const SecNav = ({ items, bg, className }) => {
  const pathname = usePathname()
  const [isActive, setIsActive] = useState([])

  const checkIsActive = (items) =>
    items.map((item) => pathname.includes(item.link))

  useEffect(() => {
    setIsActive(checkIsActive(items))
  }, [items])

  const ref = useRef()
  const { events } = useDraggable(ref)

  return (
    <nav>
      <div
        className={`flex whitespace-nowrap ${
          bg ? `bg-${bg}` : 'bg-white'
        } ${className}`}
      >
        <div className="flex pl-8 lg:pl-4 w-full bg-sec-grey-4">
          <div className="flex absolute z-10 right-0 h-[93px] lg:h-[94px] xl:h-[100px] w-10 from-sec-grey-4 bg-gradient-to-l"></div>
          <div
            className="flex overflow-x-auto scrollbar-hide"
            {...events}
            ref={ref}
          >
            <ul className="flex lg:pl-2 py-8 mr-24">
              {items.map((item, idx) => {
                return (
                  <li key={item.name}>
                    <Link
                      href={item.link}
                      className={`text-blue text-[19px] lg:text-[20px] xl:text-[24px] ml-6 lg:ml-10 border-blue ${
                        isActive[idx]
                          ? 'border-b-2'
                          : 'opacity-30 hover:border-b-2 hover:opacity-100'
                      }`}
                      onClick={() => {
                        const isActiveMod = items.map((_item) => item === _item)
                        setIsActive(isActiveMod)
                      }}
                    >
                      {item.name}
                    </Link>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default SecNav
